import { Chip } from '@sortlist-frontend/design-system';
import { formatNumber } from '@sortlist-frontend/utils';
import { useState } from 'react';

import type { GuideLabels } from '../types';
import { BarTrack } from './BarTrack';

interface BillingUnitProps {
  label: string;
  min: number;
  max: number;
  value: number;
  runs: number;
  lines: readonly { label: string; suffix: string; perStep: boolean }[];
  note: string;
  locale: string;
  labels: Pick<GuideLabels, 'executions' | 'units'>;
}

const SCALE = 30;

export const BillingUnit = (props: BillingUnitProps) => {
  const { label, min, max, value, runs, lines, note, locale, labels } = props;
  const [steps, setSteps] = useState(value);

  return (
    <div className="rounded-2xl border border-secondary-200 bg-white p-4 md:p-6">
      <label className="flex items-center justify-between gap-3 text-sm font-semibold text-secondary-950">
        <span>{label}</span>
        <Chip color="primary" variant="flat" radius="full" size="md">
          {steps}
        </Chip>
      </label>
      <input
        type="range"
        min={min}
        max={max}
        value={steps}
        aria-label={label}
        onChange={(event) => setSteps(Number(event.target.value))}
        className="mt-2 w-full accent-primary-500"
      />
      <ul className="mt-5 space-y-3" aria-live="polite">
        {lines.map((line) => {
          const amount = line.perStep ? runs * steps : runs;
          return (
            <li key={line.label}>
              <p className="mb-1 text-sm font-semibold text-secondary-950">
                {line.label} :{' '}
                <span>
                  {formatNumber({ value: amount, locale })} {line.perStep ? labels.units : labels.executions}
                </span>{' '}
                <span className="font-normal text-secondary-500">{line.suffix}</span>
              </p>
              <BarTrack label={line.label} ratio={(line.perStep ? steps : 1) / SCALE} isMuted={line.perStep} />
            </li>
          );
        })}
      </ul>
      <p className="mt-4 text-xs text-secondary-500">{note}</p>
    </div>
  );
};
